export const TOGGLE_BURGER = 'TOGGLE_BURGER';

function toggleBurger(value) {
  return {
    type: TOGGLE_BURGER,
    payload: value,
  };
}

export function toggle() {
  return (dispatch) => dispatch(toggleBurger());
}



// WEBPACK FOOTER //
// ./common/actions/burger.js